import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import DataExport from "../../../components/dashboardcomponents/Settings/DataExport";
import GroupSelectDropdown from "../../../components/dashboardcomponents/ProfileComponents/GroupSelectDropdown";
import { fetchAnalyticsExports } from "../../../store/features/getAnalyticsExports";
import { useAnalyticsGroupId } from "../../../hooks/useAnalyticsGroupId";
import { isHeaderInlinePageTitleEnabled } from "../../../config/featureFlags";
import "../Overview/style.css";

function MainAnalyticsDataExport() {
  const dispatch = useDispatch();
  const { selectedGroupId, setSelectedGroupId } = useAnalyticsGroupId();
  const { items, total, loading, error, page, limit } = useSelector(
    (state) => state.analyticsExportsList
  );

  useEffect(() => {
    if (!selectedGroupId) return;
    dispatch(fetchAnalyticsExports({ page: 1, limit: 10, group_id: selectedGroupId }));
  }, [dispatch, selectedGroupId]);

  const onPageChange = useCallback(
    (_event, newZeroBasedPage) => {
      if (!selectedGroupId) return;
      dispatch(
        fetchAnalyticsExports({
          page: newZeroBasedPage + 1,
          limit,
          group_id: selectedGroupId,
        })
      );
    },
    [dispatch, limit, selectedGroupId]
  );

  return (
    <Box
      sx={{
        pt: "16px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 85px)",
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <DataExport
        showExportButton={false}
        headerActions={
          !isHeaderInlinePageTitleEnabled ? (
            <GroupSelectDropdown
              value={selectedGroupId}
              onSelect={setSelectedGroupId}
            />
          ) : null
        }
        remoteExports={{
          items,
          total,
          loading: loading || !selectedGroupId,
          error,
          page,
          rowsPerPage: limit,
          onPageChange,
        }}
      />
    </Box>
  );
}

export default MainAnalyticsDataExport;
